export * from './ProductDetailBrandCornerSection';
export * from './ProductDetailBrandCornerValue';
